import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { user, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-200">
        Verifica credenziali…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/internal/regai-admin/login"
        replace
        state={{ from: location }}
      />
    );
  }

  return <>{children}</>;
}
